import * as React from 'react';
import { Alert, Button, Card, Slider, Spin, } from 'antd';
import { Progress } from '@ant-design/plots'
import { EntityDto } from '../../../../services/dto/entityDto';
import { L } from '../../../../lib/abpUtility';
import { LoadingOutlined, RightCircleOutlined, } from '@ant-design/icons';
import Meta from 'antd/lib/card/Meta';
import { Segmented } from 'antd';
import { SubscriptionTypes } from '../../../EntityConfigs/subscriptionTypes';
import { PagedResultDto } from '../../../../services/dto/pagedResultDto';



export interface ITenantCardProps {
    stages: any;
    currentStage: any;
    defaultIcon: any;
    primaryColor: string;
    currentState: any;
    
    entityStates: PagedResultDto<any>;
    secondaryColor: string;
    id: number;
    title: string;
    formSize: string;
    subTitle: string;
    subscriptionType: any;
    cardView(input: EntityDto): void;
    cardDelete(input: EntityDto): void;
    cardEdit(input: EntityDto): void;
    getProfileImage: () => any;
}

export interface ITenantCardState {
    optionsExpanded: boolean;
    isMobile: boolean;
    cellProgress: number;
    cellSize: number;
    currentProfileImage: string;
    actionHeight: string;
}

export class TenantCard extends React.Component<ITenantCardProps, ITenantCardState> {

    state = {
        cellSize: 0,
        cellProgress: 1,
        optionsExpanded: false,

        isMobile: false,
        actionHeight: '50px',
        currentProfileImage: '',
    };

    async componentDidMount() {


        if (window.innerWidth >= 680) {
            this.setState({ isMobile: false, })
        }
        else {
            this.setState({ isMobile: true, })
        }

        let imageURL = await this.props.getProfileImage();


        this.setState({ currentProfileImage: imageURL });
        window.addEventListener('resize', this.handleResize)
    }

    handleResize = () => {

        if (window.innerWidth >= 680) {
            this.setState({ isMobile: false, })
        }
        else {
            this.setState({ isMobile: true, })
        }

    }

    handleClickOutside = async () => {
        this.setState({ optionsExpanded: false });
        this.handleResize();
    }

    handleOptionExpand = async () => {

        if (this.state.isMobile === true) {
            this.setState({ optionsExpanded: true });
        }
        else {
            this.setState({ optionsExpanded: true });
        }
    }

    render() {

        const headerConfig = {
            percent: this.state.cellProgress,
            color: [this.props.secondaryColor, this.props.primaryColor],
        };

        const antIcon = <LoadingOutlined style={{ fontSize: 20, color: this.props.primaryColor }} spin />;

        const defaultImage =
            this.state.currentProfileImage === '' || this.state.currentProfileImage === '_'
                ? this.state.currentProfileImage !== '_'
                    ? <Spin indicator={antIcon}  >{this.props.defaultIcon}</Spin>
                    : this.props.defaultIcon : <img style={{ width: '60px', height: '60px' }}
                        src={this.state.currentProfileImage} />

        const typeStates = this.props.entityStates === undefined ? [] : this.props.entityStates.items;
        const marks: any = {};
        const markKeys: any[] = [];
        const markNames: any[] = [];
        const stateSplit = 100 / (typeStates.length - 1);
        var itemCounter = 0;
        var itemCapCounter = 0;
        const currentStateDecimal = this.props.currentState * stateSplit;

        typeStates.map((x: any) => {

            markNames.push(x.name)
            {
                itemCapCounter === typeStates.length
                    ? markKeys.push(100)
                    : itemCapCounter === 0
                        ? markKeys.push(0)
                        : markKeys.push(itemCounter)
            }

            itemCapCounter = itemCapCounter + 1;
            { itemCapCounter === 1 ? itemCounter = stateSplit : itemCounter = itemCounter + stateSplit }

        })

        markNames.forEach((value, i) => marks[markKeys[i]] = value);


        return (
            <div>


                {this.state.isMobile === true ?

                    <div>
                        <Card className="font-face-gm" bodyStyle={{ marginBottom: '-15px', }} bordered={true}
                            hoverable={true} style={{ borderColor: '#e9eaec', borderWidth: '2px', }}
                            actions={[

                                <div style={{ margin: '0', float: 'none', width: '80%', marginLeft: '10%', marginBottom: '-5px' }}>


                                    {this.props.subscriptionType === SubscriptionTypes.organization ?
                                        SubscriptionTypes.organization_Text : null}
                                    {this.props.subscriptionType === SubscriptionTypes.demo ?
                                        SubscriptionTypes.demo_Text : null}
                                    {this.props.subscriptionType === SubscriptionTypes.businessBasic ?
                                        SubscriptionTypes.businessBasic_Text : null}
                                    {this.props.subscriptionType === SubscriptionTypes.businessStandard ?
                                        SubscriptionTypes.businessStandard_Text : null}
                                    {this.props.subscriptionType === SubscriptionTypes.enterpriseAdvanced ?
                                        SubscriptionTypes.enterpriseAdvanced_Text : null}
                                    {this.props.subscriptionType === SubscriptionTypes.enterpriseUnlimited ?
                                        SubscriptionTypes.enterpriseUnlimited_Text : null}

                                    < div style={{ fontSize: '0.8em', marginTop: '8px', }}>{L('Subscription Type')}</div>
                                </div>
                            ]}
                        >


                            <div >


                                <Meta className="font-face-gm" title={<div style={{ fontSize: '1.3em', height: '30px', marginBottom: '-5px' }}>{this.props.title.length > 12 ? this.props.title.substr(0, 12) + '...' : this.props.title}</div>}
                                    avatar={defaultImage}
                                    description={this.props.subTitle.length > 15 ? this.props.subTitle.substr(0, 15) + '...' : this.props.subTitle} />

                                <div >
                                    {this.state.optionsExpanded === false ? (<div>
                                        <div>
                                            <div style={{ float: 'right', paddingTop: '10px' }}><Button className="font-face-gm" onClick={this.handleOptionExpand}
                                                style={{ minWidth: '75px', borderColor: this.props.primaryColor, color: this.props.primaryColor }} type="default">
                                                {L('Options')}
                                            </Button></div>
                                        </div></div>) : (
                                        <div>

                                            <div style={{ float: 'right', paddingTop: '10px' }}>
                                                <Button className="font-face-gm" onClick={() => this.props.cardDelete({ id: this.props.id })} style={{ marginRight: '10px', minWidth: '50px', color: this.props.secondaryColor, borderColor: this.props.secondaryColor }} type="dashed">
                                                    {L('Delete')}
                                                </Button>
                                                <Button className="font-face-gm" onClick={() => this.props.cardEdit({ id: this.props.id })} style={{ minWidth: '50px', marginRight: '10px', backgroundColor: this.props.secondaryColor, borderColor: 'white' }} type="primary">
                                                    {L('Update')}
                                                </Button>


                                                <Button className="font-face-gm" onClick={this.handleClickOutside} style={{ borderColor: this.props.secondaryColor }} type="default">
                                                    <RightCircleOutlined />
                                                </Button>
                                            </div>

                                        </div>)}
                                </div>


                            </div>



                        </Card>
                    </div >

                    :
                    <div>
                        <Card className="font-face-gm" bodyStyle={{ marginBottom: '-15px', }} bordered={true}
                            hoverable={true} style={{ borderColor: '#e9eaec', borderWidth: '2px', }}
                            actions={[

                                <div style={{ margin: '0', float: 'none', width: '80%', marginLeft: '10%', marginBottom: '-5px' }}>

                                    {this.props.currentStage === 0 ?
                                        <Alert className="font-face-gm" message={L('Inactive')} type="info" style={{ opacity: '0.8' }} /> : null}
                                    {this.props.currentStage === 1 ?
                                        <Alert className="font-face-gm" message={L('Awaiting Approval')} type="warning" style={{ opacity: '0.8' }} /> : null}
                                    {this.props.currentStage === 2 ?
                                        <Alert className="font-face-gm" message={L('Onboarding')} type="info" style={{ opacity: '0.8' }} /> : null}
                                    {this.props.currentStage === 3 ?
                                        <Alert className="font-face-gm" message={L('Active')} type="success" style={{ opacity: '0.8' }} /> : null}

                                    <div style={{ fontSize: '0.8em', marginTop: '8px', }}>{L('Account Status')}</div>
                                </div>,
                                <div style={{ margin: '0', float: 'none', marginTop: '2px', }}>
                                    <div style={{ fontSize: '1.6em' }}>
                                        {this.props.subscriptionType === SubscriptionTypes.organization ?
                                            SubscriptionTypes.organization_Text : null}
                                        {this.props.subscriptionType === SubscriptionTypes.demo ?
                                            SubscriptionTypes.demo_Text : null}
                                        {this.props.subscriptionType === SubscriptionTypes.businessBasic ?
                                            SubscriptionTypes.businessBasic_Text : null}
                                        {this.props.subscriptionType === SubscriptionTypes.businessStandard ?
                                            SubscriptionTypes.businessStandard_Text : null}
                                        {this.props.subscriptionType === SubscriptionTypes.enterpriseAdvanced ?
                                            SubscriptionTypes.enterpriseAdvanced_Text : null}
                                        {this.props.subscriptionType === SubscriptionTypes.enterpriseUnlimited ?
                                            SubscriptionTypes.enterpriseUnlimited_Text : null}
                                    </div>

                                    <div style={{ fontSize: '0.8em', marginTop: '11px', }}>{L('Subscription Type')}</div>
                                </div>,
                                <div style={{ margin: '0', float: 'none', marginBottom: '-5px' }}>

                                    <Segmented className="font-face-gm" defaultValue={'Activity'} options={['Activity']} style={{ marginTop: '6px', }} onResize={undefined} onResizeCapture={undefined} />
                                    <div style={{ fontSize: '0.8em', marginTop: '10px', }}>{L('Quick Actions')}</div>
                                </div>,
                            ]}

                            cover={

                                <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                                    <Progress height={25} autoFit={true} style={{ marginTop: '-12px', width: '96%' }} {...headerConfig} /></div>
                            }
                        >


                            <div style={{ height: '60px' }} >

                                <div >
                                    {this.state.optionsExpanded === false ? (
                                        <div>


                                            <div style={{ float: 'right', }}>


                                                <Button className="font-face-gm" onClick={this.handleOptionExpand}
                                                    style={{
                                                        minWidth: '75px',
                                                        borderColor: this.props.primaryColor,
                                                        color: this.props.primaryColor
                                                    }} type="default">
                                                    {L('Options')}
                                                </Button>


                                            </div>


                                            <div style={{ width: '40%', float: 'right', marginRight: '12%' }}>

                                                <div style={{ fontSize: '0.8em', }}>{L('Lifecycle Stage')}</div>
                                                <Slider

                                                    className="font-face-gm" disabled={true} tooltipVisible={false} step={null} marks={marks}
                                                    defaultValue={currentStateDecimal} />
                                            </div>


                                        </div>) : (
                                        <div>



                                            <div style={{ float: 'right' }}>





                                                <Button className="font-face-gm" onClick={() => this.props.cardDelete({ id: this.props.id })} style={{ marginRight: '10px', minWidth: '50px', color: this.props.secondaryColor, borderColor: this.props.secondaryColor }} type="dashed">
                                                    {L('Delete')}
                                                </Button>
                                                <Button className="font-face-gm" onClick={() => this.props.cardEdit({ id: this.props.id })} style={{ minWidth: '50px', marginRight: '10px', backgroundColor: this.props.secondaryColor, borderColor: 'white' }} type="primary">
                                                    {L('Update')}
                                                </Button>


                                                <Button className="font-face-gm" onClick={this.handleClickOutside} style={{ borderColor: this.props.secondaryColor }} type="default">
                                                    <RightCircleOutlined />
                                                </Button>
                                            </div>

                                        </div>)}
                                </div>



                                <Meta className="font-face-gm" title={<div style={{ fontSize: '1.3em', paddingBottom: '0px', marginBottom: '0px' }}>{this.props.title.length > 18 ? this.props.title.substr(0, 18) + '...' : this.props.title}</div>}
                                    avatar={defaultImage}

                                    description={<div style={{ paddingTop: '0px', marginTop: '-15px' }}>{this.props.subTitle.length > 18 ? this.props.subTitle.substr(0, 18) + '...' : this.props.subTitle}</div>} />


                            </div>



                        </Card>
                    </div>
                }


            </div>
        );
    }
}

export default TenantCard;
